import { lazy, Suspense } from "react";
import CircularLoader from "../custom/circularLoader/circularLoader";

const Main = lazy(() => import("../components/signUp/main"));


const SignUp = () => {
    return (
        <Suspense fallback={<CircularLoader />}>
            <Main />
        </Suspense>
    )
}
export default SignUp;